const ThreeMonthPlannerInstructions = () => (
    <div className="instructions">
        <h2>Seasonal Planner Instructions</h2>
        <ul>
            <p>You are viewing a 3-month seasonal preview. This is a planning tool... your actual</p>
            <p>planting tasks will be sent as notifications when conditions are right.</p>
            <p>Soil temperature, frost risk, and weather patterns are monitored in the background.</p>
            <p>Use this view to prepare, organize, and visualize your growing season.</p>
        </ul>

    </div>
);
export default ThreeMonthPlannerInstructions;
